//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAccess(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Access";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccess(_response);
        });
    }

    protected processGetAccess(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param search (optional) 
     * @return Success
     */
    getAlphaTagFilters(search: string | undefined): Promise<Filter[]> {
        let url_ = this.baseUrl + "/api/AlphaTags/filters?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlphaTagFilters(_response);
        });
    }

    protected processGetAlphaTagFilters(response: Response): Promise<Filter[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Filter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Filter[]>(null as any);
    }

    /**
     * @param abns (optional) 
     * @param names (optional) 
     * @param mnos (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param sortingDesc (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getAlphaTags(abns: string[] | undefined, names: string[] | undefined, mnos: string[] | undefined, search: string | undefined, sorting: Hint | undefined, sortingDesc: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<AlphaTag[]> {
        let url_ = this.baseUrl + "/api/AlphaTags?";
        if (abns === null)
            throw new Error("The parameter 'abns' cannot be null.");
        else if (abns !== undefined)
            abns && abns.forEach(item => { url_ += "abns=" + encodeURIComponent("" + item) + "&"; });
        if (names === null)
            throw new Error("The parameter 'names' cannot be null.");
        else if (names !== undefined)
            names && names.forEach(item => { url_ += "names=" + encodeURIComponent("" + item) + "&"; });
        if (mnos === null)
            throw new Error("The parameter 'mnos' cannot be null.");
        else if (mnos !== undefined)
            mnos && mnos.forEach(item => { url_ += "mnos=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sortingDesc === null)
            throw new Error("The parameter 'sortingDesc' cannot be null.");
        else if (sortingDesc !== undefined)
            url_ += "sortingDesc=" + encodeURIComponent("" + sortingDesc) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlphaTags(_response);
        });
    }

    protected processGetAlphaTags(response: Response): Promise<AlphaTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlphaTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlphaTag[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addAlphaTags(body: AlphaTagPayload | undefined): Promise<AlphaTag[]> {
        let url_ = this.baseUrl + "/api/AlphaTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAlphaTags(_response);
        });
    }

    protected processAddAlphaTags(response: Response): Promise<AlphaTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlphaTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = MessageResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlphaTag[]>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteAlphaTags(ids: string[] | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/AlphaTags?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAlphaTags(_response);
        });
    }

    protected processDeleteAlphaTags(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param abns (optional) 
     * @param names (optional) 
     * @param mnos (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param sortingDesc (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    odata_AlphaTags(abns: string[] | undefined, names: string[] | undefined, mnos: string[] | undefined, search: string | undefined, sorting: Hint | undefined, sortingDesc: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<AlphaTag[]> {
        let url_ = this.baseUrl + "/odata/AlphaTags?";
        if (abns === null)
            throw new Error("The parameter 'abns' cannot be null.");
        else if (abns !== undefined)
            abns && abns.forEach(item => { url_ += "abns=" + encodeURIComponent("" + item) + "&"; });
        if (names === null)
            throw new Error("The parameter 'names' cannot be null.");
        else if (names !== undefined)
            names && names.forEach(item => { url_ += "names=" + encodeURIComponent("" + item) + "&"; });
        if (mnos === null)
            throw new Error("The parameter 'mnos' cannot be null.");
        else if (mnos !== undefined)
            mnos && mnos.forEach(item => { url_ += "mnos=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sortingDesc === null)
            throw new Error("The parameter 'sortingDesc' cannot be null.");
        else if (sortingDesc !== undefined)
            url_ += "sortingDesc=" + encodeURIComponent("" + sortingDesc) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOdata_AlphaTags(_response);
        });
    }

    protected processOdata_AlphaTags(response: Response): Promise<AlphaTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlphaTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlphaTag[]>(null as any);
    }

    /**
     * @param abns (optional) 
     * @param names (optional) 
     * @param mnos (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param sortingDesc (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    odata_AlphaTags_$count(abns: string[] | undefined, names: string[] | undefined, mnos: string[] | undefined, search: string | undefined, sorting: Hint | undefined, sortingDesc: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<AlphaTag[]> {
        let url_ = this.baseUrl + "/odata/AlphaTags/$count?";
        if (abns === null)
            throw new Error("The parameter 'abns' cannot be null.");
        else if (abns !== undefined)
            abns && abns.forEach(item => { url_ += "abns=" + encodeURIComponent("" + item) + "&"; });
        if (names === null)
            throw new Error("The parameter 'names' cannot be null.");
        else if (names !== undefined)
            names && names.forEach(item => { url_ += "names=" + encodeURIComponent("" + item) + "&"; });
        if (mnos === null)
            throw new Error("The parameter 'mnos' cannot be null.");
        else if (mnos !== undefined)
            mnos && mnos.forEach(item => { url_ += "mnos=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sortingDesc === null)
            throw new Error("The parameter 'sortingDesc' cannot be null.");
        else if (sortingDesc !== undefined)
            url_ += "sortingDesc=" + encodeURIComponent("" + sortingDesc) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOdata_AlphaTags_$count(_response);
        });
    }

    protected processOdata_AlphaTags_$count(response: Response): Promise<AlphaTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlphaTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlphaTag[]>(null as any);
    }

    /**
     * @param search (optional) 
     * @return Success
     */
    getAuthorisationFilters(search: string | undefined): Promise<Filter[]> {
        let url_ = this.baseUrl + "/api/Authorisations/filters?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuthorisationFilters(_response);
        });
    }

    protected processGetAuthorisationFilters(response: Response): Promise<Filter[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Filter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Filter[]>(null as any);
    }

    /**
     * @param abns (optional) 
     * @param names (optional) 
     * @param parties (optional) 
     * @param contacts (optional) 
     * @param statuses (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param sortingDesc (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getAuthorisations(abns: string[] | undefined, names: string[] | undefined, parties: string[] | undefined, contacts: string[] | undefined, statuses: Acma_senderidauthorisation_statuscode[] | undefined, search: string | undefined, sorting: Hint | undefined, sortingDesc: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<Authorisation[]> {
        let url_ = this.baseUrl + "/api/Authorisations?";
        if (abns === null)
            throw new Error("The parameter 'abns' cannot be null.");
        else if (abns !== undefined)
            abns && abns.forEach(item => { url_ += "abns=" + encodeURIComponent("" + item) + "&"; });
        if (names === null)
            throw new Error("The parameter 'names' cannot be null.");
        else if (names !== undefined)
            names && names.forEach(item => { url_ += "names=" + encodeURIComponent("" + item) + "&"; });
        if (parties === null)
            throw new Error("The parameter 'parties' cannot be null.");
        else if (parties !== undefined)
            parties && parties.forEach(item => { url_ += "parties=" + encodeURIComponent("" + item) + "&"; });
        if (contacts === null)
            throw new Error("The parameter 'contacts' cannot be null.");
        else if (contacts !== undefined)
            contacts && contacts.forEach(item => { url_ += "contacts=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sortingDesc === null)
            throw new Error("The parameter 'sortingDesc' cannot be null.");
        else if (sortingDesc !== undefined)
            url_ += "sortingDesc=" + encodeURIComponent("" + sortingDesc) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuthorisations(_response);
        });
    }

    protected processGetAuthorisations(response: Response): Promise<Authorisation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Authorisation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorisation[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addAuthorisations(body: AuthorisationPayload | undefined): Promise<Authorisation[]> {
        let url_ = this.baseUrl + "/api/Authorisations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAuthorisations(_response);
        });
    }

    protected processAddAuthorisations(response: Response): Promise<Authorisation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Authorisation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorisation[]>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    revokeAuthorisation(ids: string[] | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Authorisations?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRevokeAuthorisation(_response);
        });
    }

    protected processRevokeAuthorisation(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    approveAuthorisation(ids: string[] | undefined): Promise<Authorisation[]> {
        let url_ = this.baseUrl + "/api/Authorisations?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveAuthorisation(_response);
        });
    }

    protected processApproveAuthorisation(response: Response): Promise<Authorisation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Authorisation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorisation[]>(null as any);
    }

    /**
     * @param search (optional) 
     * @return Success
     */
    getFirewalledAlphaTagFilters(search: string | undefined): Promise<Filter[]> {
        let url_ = this.baseUrl + "/api/Firewall/filters?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFirewalledAlphaTagFilters(_response);
        });
    }

    protected processGetFirewalledAlphaTagFilters(response: Response): Promise<Filter[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Filter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Filter[]>(null as any);
    }

    /**
     * @param abns (optional) 
     * @param names (optional) 
     * @param contacts (optional) 
     * @param mnos (optional) 
     * @param statuses (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param sortingDesc (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getFirewalledAlphaTags(abns: string[] | undefined, names: string[] | undefined, contacts: string[] | undefined, mnos: string[] | undefined, statuses: FirewallStatus[] | undefined, search: string | undefined, sorting: Hint | undefined, sortingDesc: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<FirewallAlphaTag[]> {
        let url_ = this.baseUrl + "/api/Firewall?";
        if (abns === null)
            throw new Error("The parameter 'abns' cannot be null.");
        else if (abns !== undefined)
            abns && abns.forEach(item => { url_ += "abns=" + encodeURIComponent("" + item) + "&"; });
        if (names === null)
            throw new Error("The parameter 'names' cannot be null.");
        else if (names !== undefined)
            names && names.forEach(item => { url_ += "names=" + encodeURIComponent("" + item) + "&"; });
        if (contacts === null)
            throw new Error("The parameter 'contacts' cannot be null.");
        else if (contacts !== undefined)
            contacts && contacts.forEach(item => { url_ += "contacts=" + encodeURIComponent("" + item) + "&"; });
        if (mnos === null)
            throw new Error("The parameter 'mnos' cannot be null.");
        else if (mnos !== undefined)
            mnos && mnos.forEach(item => { url_ += "mnos=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sortingDesc === null)
            throw new Error("The parameter 'sortingDesc' cannot be null.");
        else if (sortingDesc !== undefined)
            url_ += "sortingDesc=" + encodeURIComponent("" + sortingDesc) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFirewalledAlphaTags(_response);
        });
    }

    protected processGetFirewalledAlphaTags(response: Response): Promise<FirewallAlphaTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FirewallAlphaTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FirewallAlphaTag[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeFirewall(body: FirewallPayload | undefined): Promise<FirewallAlphaTag[]> {
        let url_ = this.baseUrl + "/api/Firewall";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompleteFirewall(_response);
        });
    }

    protected processCompleteFirewall(response: Response): Promise<FirewallAlphaTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FirewallAlphaTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = MessageResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FirewallAlphaTag[]>(null as any);
    }

    /**
     * @param abns (optional) 
     * @param names (optional) 
     * @param contacts (optional) 
     * @param mnos (optional) 
     * @param statuses (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param sortingDesc (optional) 
     * @return Success
     */
    exportFirewalledAlphaTags(abns: string[] | undefined, names: string[] | undefined, contacts: string[] | undefined, mnos: string[] | undefined, statuses: FirewallStatus[] | undefined, search: string | undefined, sorting: Hint | undefined, sortingDesc: boolean | undefined): Promise<Authorisation[]> {
        let url_ = this.baseUrl + "/api/Firewall/export?";
        if (abns === null)
            throw new Error("The parameter 'abns' cannot be null.");
        else if (abns !== undefined)
            abns && abns.forEach(item => { url_ += "abns=" + encodeURIComponent("" + item) + "&"; });
        if (names === null)
            throw new Error("The parameter 'names' cannot be null.");
        else if (names !== undefined)
            names && names.forEach(item => { url_ += "names=" + encodeURIComponent("" + item) + "&"; });
        if (contacts === null)
            throw new Error("The parameter 'contacts' cannot be null.");
        else if (contacts !== undefined)
            contacts && contacts.forEach(item => { url_ += "contacts=" + encodeURIComponent("" + item) + "&"; });
        if (mnos === null)
            throw new Error("The parameter 'mnos' cannot be null.");
        else if (mnos !== undefined)
            mnos && mnos.forEach(item => { url_ += "mnos=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sortingDesc === null)
            throw new Error("The parameter 'sortingDesc' cannot be null.");
        else if (sortingDesc !== undefined)
            url_ += "sortingDesc=" + encodeURIComponent("" + sortingDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportFirewalledAlphaTags(_response);
        });
    }

    protected processExportFirewalledAlphaTags(response: Response): Promise<Authorisation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Authorisation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorisation[]>(null as any);
    }

    /**
     * @return Success
     */
    odata_$metadata(): Promise<IEdmModel> {
        let url_ = this.baseUrl + "/odata/$metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOdata_$metadata(_response);
        });
    }

    protected processOdata_$metadata(response: Response): Promise<IEdmModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IEdmModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IEdmModel>(null as any);
    }

    /**
     * @return Success
     */
    odata_(): Promise<ODataServiceDocument> {
        let url_ = this.baseUrl + "/odata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOdata_(_response);
        });
    }

    protected processOdata_(response: Response): Promise<ODataServiceDocument> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataServiceDocument.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ODataServiceDocument>(null as any);
    }

    /**
     * @param search (optional) 
     * @return Success
     */
    getProhibitedAlphaTagFilters(search: string | undefined): Promise<Filter[]> {
        let url_ = this.baseUrl + "/api/ProhibitedAlphaTags/filters?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProhibitedAlphaTagFilters(_response);
        });
    }

    protected processGetProhibitedAlphaTagFilters(response: Response): Promise<Filter[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Filter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Filter[]>(null as any);
    }

    /**
     * @param names (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param sortingDesc (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getProhibitedAlphaTags(names: string[] | undefined, search: string | undefined, sorting: Hint | undefined, sortingDesc: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<ProhibitedAlphaTag[]> {
        let url_ = this.baseUrl + "/api/ProhibitedAlphaTags?";
        if (names === null)
            throw new Error("The parameter 'names' cannot be null.");
        else if (names !== undefined)
            names && names.forEach(item => { url_ += "names=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sortingDesc === null)
            throw new Error("The parameter 'sortingDesc' cannot be null.");
        else if (sortingDesc !== undefined)
            url_ += "sortingDesc=" + encodeURIComponent("" + sortingDesc) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProhibitedAlphaTags(_response);
        });
    }

    protected processGetProhibitedAlphaTags(response: Response): Promise<ProhibitedAlphaTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProhibitedAlphaTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProhibitedAlphaTag[]>(null as any);
    }

    /**
     * @param search (optional) 
     * @return Success
     */
    getRegisteredAlphaTagFilters(search: string | undefined): Promise<Filter[]> {
        let url_ = this.baseUrl + "/api/Register/filters?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRegisteredAlphaTagFilters(_response);
        });
    }

    protected processGetRegisteredAlphaTagFilters(response: Response): Promise<Filter[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Filter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Filter[]>(null as any);
    }

    /**
     * @param abns (optional) 
     * @param names (optional) 
     * @param contacts (optional) 
     * @param statuses (optional) 
     * @param search (optional) 
     * @param sorting (optional) 
     * @param sortingDesc (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getRegisteredAlphaTags(abns: string[] | undefined, names: string[] | undefined, contacts: string[] | undefined, statuses: Acma_senderidauthorisation_statuscode[] | undefined, search: string | undefined, sorting: Hint | undefined, sortingDesc: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<Authorisation[]> {
        let url_ = this.baseUrl + "/api/Register?";
        if (abns === null)
            throw new Error("The parameter 'abns' cannot be null.");
        else if (abns !== undefined)
            abns && abns.forEach(item => { url_ += "abns=" + encodeURIComponent("" + item) + "&"; });
        if (names === null)
            throw new Error("The parameter 'names' cannot be null.");
        else if (names !== undefined)
            names && names.forEach(item => { url_ += "names=" + encodeURIComponent("" + item) + "&"; });
        if (contacts === null)
            throw new Error("The parameter 'contacts' cannot be null.");
        else if (contacts !== undefined)
            contacts && contacts.forEach(item => { url_ += "contacts=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sortingDesc === null)
            throw new Error("The parameter 'sortingDesc' cannot be null.");
        else if (sortingDesc !== undefined)
            url_ += "sortingDesc=" + encodeURIComponent("" + sortingDesc) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRegisteredAlphaTags(_response);
        });
    }

    protected processGetRegisteredAlphaTags(response: Response): Promise<Authorisation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Authorisation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorisation[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestAuthorisations(body: AuthorisationRequest | undefined): Promise<Authorisation[]> {
        let url_ = this.baseUrl + "/api/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestAuthorisations(_response);
        });
    }

    protected processRequestAuthorisations(response: Response): Promise<Authorisation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Authorisation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = MessageResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorisation[]>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    cancelAuthorisations(ids: string[] | undefined): Promise<Authorisation[]> {
        let url_ = this.baseUrl + "/api/Register?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelAuthorisations(_response);
        });
    }

    protected processCancelAuthorisations(response: Response): Promise<Authorisation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Authorisation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = MessageResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorisation[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateToken(body: AuthorisationToken | undefined): Promise<Authorisation[]> {
        let url_ = this.baseUrl + "/api/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateToken(_response);
        });
    }

    protected processValidateToken(response: Response): Promise<Authorisation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Authorisation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Authorisation[]>(null as any);
    }

    /**
     * @return Success
     */
    getSettings(): Promise<SettingPayload> {
        let url_ = this.baseUrl + "/api/Settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: Response): Promise<SettingPayload> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingPayload.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettingPayload>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSettings(body: SettingsBase[] | undefined): Promise<Settings[]> {
        let url_ = this.baseUrl + "/api/Settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSettings(_response);
        });
    }

    protected processUpdateSettings(response: Response): Promise<Settings[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Settings.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Settings[]>(null as any);
    }

    /**
     * @return Success
     */
    consent(): Promise<void> {
        let url_ = this.baseUrl + "/api/Settings/consent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConsent(_response);
        });
    }

    protected processConsent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export enum Acma_senderid_statecode {
    Active = "Active",
    Inactive = "Inactive",
}

export enum Acma_senderidauthorisation_statuscode {
    Approved = "Approved",
    Revoked = "Revoked",
    Issued = "Issued",
    Requested = "Requested",
}

export enum Acma_senderidimplementation_statuscode {
    Added = "Added",
    Removed = "Removed",
    Declined = "Declined",
}

export class AlphaTag implements IAlphaTag {
    alphaTagId?: string | undefined;
    name?: string | undefined;
    mnoId?: string | undefined;
    clientName?: string | undefined;
    clientABN?: string | undefined;
    createdOn?: Date | undefined;
    state?: Acma_senderid_statecode;

    constructor(data?: IAlphaTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alphaTagId = _data["alphaTagId"];
            this.name = _data["name"];
            this.mnoId = _data["mnoId"];
            this.clientName = _data["clientName"];
            this.clientABN = _data["clientABN"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): AlphaTag {
        data = typeof data === 'object' ? data : {};
        let result = new AlphaTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alphaTagId"] = this.alphaTagId;
        data["name"] = this.name;
        data["mnoId"] = this.mnoId;
        data["clientName"] = this.clientName;
        data["clientABN"] = this.clientABN;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data;
    }
}

export interface IAlphaTag {
    alphaTagId?: string | undefined;
    name?: string | undefined;
    mnoId?: string | undefined;
    clientName?: string | undefined;
    clientABN?: string | undefined;
    createdOn?: Date | undefined;
    state?: Acma_senderid_statecode;
}

export class AlphaTagPayload implements IAlphaTagPayload {
    clientAbn?: string | undefined;
    mnoId?: string | undefined;
    names?: string[] | undefined;

    constructor(data?: IAlphaTagPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientAbn = _data["clientAbn"];
            this.mnoId = _data["mnoId"];
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(item);
            }
        }
    }

    static fromJS(data: any): AlphaTagPayload {
        data = typeof data === 'object' ? data : {};
        let result = new AlphaTagPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientAbn"] = this.clientAbn;
        data["mnoId"] = this.mnoId;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item);
        }
        return data;
    }
}

export interface IAlphaTagPayload {
    clientAbn?: string | undefined;
    mnoId?: string | undefined;
    names?: string[] | undefined;
}

export class Authorisation implements IAuthorisation {
    authorisationId?: string | undefined;
    partyName?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    token?: string | undefined;
    status?: Acma_senderidauthorisation_statuscode;
    alphaTagId?: string | undefined;
    name?: string | undefined;
    mnoId?: string | undefined;
    clientName?: string | undefined;
    clientABN?: string | undefined;
    createdOn?: Date | undefined;
    state?: Acma_senderid_statecode;

    constructor(data?: IAuthorisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorisationId = _data["authorisationId"];
            this.partyName = _data["partyName"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.token = _data["token"];
            this.status = _data["status"];
            this.alphaTagId = _data["alphaTagId"];
            this.name = _data["name"];
            this.mnoId = _data["mnoId"];
            this.clientName = _data["clientName"];
            this.clientABN = _data["clientABN"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): Authorisation {
        data = typeof data === 'object' ? data : {};
        let result = new Authorisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorisationId"] = this.authorisationId;
        data["partyName"] = this.partyName;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["token"] = this.token;
        data["status"] = this.status;
        data["alphaTagId"] = this.alphaTagId;
        data["name"] = this.name;
        data["mnoId"] = this.mnoId;
        data["clientName"] = this.clientName;
        data["clientABN"] = this.clientABN;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data;
    }
}

export interface IAuthorisation {
    authorisationId?: string | undefined;
    partyName?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    token?: string | undefined;
    status?: Acma_senderidauthorisation_statuscode;
    alphaTagId?: string | undefined;
    name?: string | undefined;
    mnoId?: string | undefined;
    clientName?: string | undefined;
    clientABN?: string | undefined;
    createdOn?: Date | undefined;
    state?: Acma_senderid_statecode;
}

export class AuthorisationPayload implements IAuthorisationPayload {
    alphaTagIds?: string[] | undefined;
    partyName?: string | undefined;

    constructor(data?: IAuthorisationPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["alphaTagIds"])) {
                this.alphaTagIds = [] as any;
                for (let item of _data["alphaTagIds"])
                    this.alphaTagIds!.push(item);
            }
            this.partyName = _data["partyName"];
        }
    }

    static fromJS(data: any): AuthorisationPayload {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorisationPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.alphaTagIds)) {
            data["alphaTagIds"] = [];
            for (let item of this.alphaTagIds)
                data["alphaTagIds"].push(item);
        }
        data["partyName"] = this.partyName;
        return data;
    }
}

export interface IAuthorisationPayload {
    alphaTagIds?: string[] | undefined;
    partyName?: string | undefined;
}

export class AuthorisationRequest implements IAuthorisationRequest {
    alphaTagIds?: string[] | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;

    constructor(data?: IAuthorisationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["alphaTagIds"])) {
                this.alphaTagIds = [] as any;
                for (let item of _data["alphaTagIds"])
                    this.alphaTagIds!.push(item);
            }
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
        }
    }

    static fromJS(data: any): AuthorisationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorisationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.alphaTagIds)) {
            data["alphaTagIds"] = [];
            for (let item of this.alphaTagIds)
                data["alphaTagIds"].push(item);
        }
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        return data;
    }
}

export interface IAuthorisationRequest {
    alphaTagIds?: string[] | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
}

export class AuthorisationToken implements IAuthorisationToken {
    token?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;

    constructor(data?: IAuthorisationToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
        }
    }

    static fromJS(data: any): AuthorisationToken {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorisationToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        return data;
    }
}

export interface IAuthorisationToken {
    token?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
}

export enum EdmContainerElementKind {
    None = "None",
    EntitySet = "EntitySet",
    ActionImport = "ActionImport",
    FunctionImport = "FunctionImport",
    Singleton = "Singleton",
}

export enum EdmExpressionKind {
    None = "None",
    BinaryConstant = "BinaryConstant",
    BooleanConstant = "BooleanConstant",
    DateTimeOffsetConstant = "DateTimeOffsetConstant",
    DecimalConstant = "DecimalConstant",
    FloatingConstant = "FloatingConstant",
    GuidConstant = "GuidConstant",
    IntegerConstant = "IntegerConstant",
    StringConstant = "StringConstant",
    DurationConstant = "DurationConstant",
    Null = "Null",
    Record = "Record",
    Collection = "Collection",
    Path = "Path",
    If = "If",
    Cast = "Cast",
    IsType = "IsType",
    FunctionApplication = "FunctionApplication",
    LabeledExpressionReference = "LabeledExpressionReference",
    Labeled = "Labeled",
    PropertyPath = "PropertyPath",
    NavigationPropertyPath = "NavigationPropertyPath",
    DateConstant = "DateConstant",
    TimeOfDayConstant = "TimeOfDayConstant",
    EnumMember = "EnumMember",
    AnnotationPath = "AnnotationPath",
}

export enum EdmSchemaElementKind {
    None = "None",
    TypeDefinition = "TypeDefinition",
    Term = "Term",
    Action = "Action",
    EntityContainer = "EntityContainer",
    Function = "Function",
}

export enum EdmTypeKind {
    None = "None",
    Primitive = "Primitive",
    Entity = "Entity",
    Complex = "Complex",
    Collection = "Collection",
    EntityReference = "EntityReference",
    Enum = "Enum",
    TypeDefinition = "TypeDefinition",
    Untyped = "Untyped",
    Path = "Path",
}

export class Filter implements IFilter {
    hint?: Hint;
    value?: string | undefined;
    label?: string | undefined;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hint = _data["hint"];
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hint"] = this.hint;
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IFilter {
    hint?: Hint;
    value?: string | undefined;
    label?: string | undefined;
}

export class FirewallAlphaTag implements IFirewallAlphaTag {
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    implementations?: FirewallImplementation[] | undefined;
    status?: FirewallStatus;
    alphaTagId?: string | undefined;
    name?: string | undefined;
    mnoId?: string | undefined;
    clientName?: string | undefined;
    clientABN?: string | undefined;
    createdOn?: Date | undefined;
    state?: Acma_senderid_statecode;

    constructor(data?: IFirewallAlphaTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            if (Array.isArray(_data["implementations"])) {
                this.implementations = [] as any;
                for (let item of _data["implementations"])
                    this.implementations!.push(FirewallImplementation.fromJS(item));
            }
            this.status = _data["status"];
            this.alphaTagId = _data["alphaTagId"];
            this.name = _data["name"];
            this.mnoId = _data["mnoId"];
            this.clientName = _data["clientName"];
            this.clientABN = _data["clientABN"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): FirewallAlphaTag {
        data = typeof data === 'object' ? data : {};
        let result = new FirewallAlphaTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        if (Array.isArray(this.implementations)) {
            data["implementations"] = [];
            for (let item of this.implementations)
                data["implementations"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["alphaTagId"] = this.alphaTagId;
        data["name"] = this.name;
        data["mnoId"] = this.mnoId;
        data["clientName"] = this.clientName;
        data["clientABN"] = this.clientABN;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data;
    }
}

export interface IFirewallAlphaTag {
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    implementations?: FirewallImplementation[] | undefined;
    status?: FirewallStatus;
    alphaTagId?: string | undefined;
    name?: string | undefined;
    mnoId?: string | undefined;
    clientName?: string | undefined;
    clientABN?: string | undefined;
    createdOn?: Date | undefined;
    state?: Acma_senderid_statecode;
}

export class FirewallImplementation implements IFirewallImplementation {
    implementerId?: string | undefined;
    status?: Acma_senderidimplementation_statuscode;
    comments?: string | undefined;
    date?: Date | undefined;

    constructor(data?: IFirewallImplementation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.implementerId = _data["implementerId"];
            this.status = _data["status"];
            this.comments = _data["comments"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FirewallImplementation {
        data = typeof data === 'object' ? data : {};
        let result = new FirewallImplementation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["implementerId"] = this.implementerId;
        data["status"] = this.status;
        data["comments"] = this.comments;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFirewallImplementation {
    implementerId?: string | undefined;
    status?: Acma_senderidimplementation_statuscode;
    comments?: string | undefined;
    date?: Date | undefined;
}

export class FirewallPayload implements IFirewallPayload {
    alphaTagIds?: string[] | undefined;
    comments?: string | undefined;
    declined?: boolean | undefined;

    constructor(data?: IFirewallPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["alphaTagIds"])) {
                this.alphaTagIds = [] as any;
                for (let item of _data["alphaTagIds"])
                    this.alphaTagIds!.push(item);
            }
            this.comments = _data["comments"];
            this.declined = _data["declined"];
        }
    }

    static fromJS(data: any): FirewallPayload {
        data = typeof data === 'object' ? data : {};
        let result = new FirewallPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.alphaTagIds)) {
            data["alphaTagIds"] = [];
            for (let item of this.alphaTagIds)
                data["alphaTagIds"].push(item);
        }
        data["comments"] = this.comments;
        data["declined"] = this.declined;
        return data;
    }
}

export interface IFirewallPayload {
    alphaTagIds?: string[] | undefined;
    comments?: string | undefined;
    declined?: boolean | undefined;
}

export enum FirewallStatus {
    Pending = "Pending",
    CompletedAwaitingOthers = "CompletedAwaitingOthers",
    CompletedActionedByAll = "CompletedActionedByAll",
    Declined = "Declined",
}

export enum Hint {
    Name = "Name",
    Abn = "Abn",
    Company = "Company",
    Status = "Status",
    Party = "Party",
    CreatedOn = "CreatedOn",
    Contact = "Contact",
    MNO = "MNO",
}

export class IEdmDirectValueAnnotationsManager implements IIEdmDirectValueAnnotationsManager {

    constructor(data?: IIEdmDirectValueAnnotationsManager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IEdmDirectValueAnnotationsManager {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmDirectValueAnnotationsManager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIEdmDirectValueAnnotationsManager {
}

export class IEdmEntityContainer implements IIEdmEntityContainer {
    readonly elements?: IEdmEntityContainerElement[] | undefined;
    schemaElementKind?: EdmSchemaElementKind;
    readonly namespace?: string | undefined;
    readonly name?: string | undefined;

    constructor(data?: IIEdmEntityContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                (<any>this).elements = [] as any;
                for (let item of _data["elements"])
                    (<any>this).elements!.push(IEdmEntityContainerElement.fromJS(item));
            }
            this.schemaElementKind = _data["schemaElementKind"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): IEdmEntityContainer {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmEntityContainer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["schemaElementKind"] = this.schemaElementKind;
        data["namespace"] = this.namespace;
        data["name"] = this.name;
        return data;
    }
}

export interface IIEdmEntityContainer {
    elements?: IEdmEntityContainerElement[] | undefined;
    schemaElementKind?: EdmSchemaElementKind;
    namespace?: string | undefined;
    name?: string | undefined;
}

export class IEdmEntityContainerElement implements IIEdmEntityContainerElement {
    containerElementKind?: EdmContainerElementKind;
    container?: IEdmEntityContainer;
    readonly name?: string | undefined;

    constructor(data?: IIEdmEntityContainerElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.containerElementKind = _data["containerElementKind"];
            this.container = _data["container"] ? IEdmEntityContainer.fromJS(_data["container"]) : <any>undefined;
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): IEdmEntityContainerElement {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmEntityContainerElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["containerElementKind"] = this.containerElementKind;
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IIEdmEntityContainerElement {
    containerElementKind?: EdmContainerElementKind;
    container?: IEdmEntityContainer;
    name?: string | undefined;
}

export class IEdmExpression implements IIEdmExpression {
    expressionKind?: EdmExpressionKind;

    constructor(data?: IIEdmExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressionKind = _data["expressionKind"];
        }
    }

    static fromJS(data: any): IEdmExpression {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmExpression();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressionKind"] = this.expressionKind;
        return data;
    }
}

export interface IIEdmExpression {
    expressionKind?: EdmExpressionKind;
}

export class IEdmModel implements IIEdmModel {
    readonly schemaElements?: IEdmSchemaElement[] | undefined;
    readonly vocabularyAnnotations?: IEdmVocabularyAnnotation[] | undefined;
    readonly referencedModels?: IEdmModel[] | undefined;
    readonly declaredNamespaces?: string[] | undefined;
    directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager;
    entityContainer?: IEdmEntityContainer;

    constructor(data?: IIEdmModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["schemaElements"])) {
                (<any>this).schemaElements = [] as any;
                for (let item of _data["schemaElements"])
                    (<any>this).schemaElements!.push(IEdmSchemaElement.fromJS(item));
            }
            if (Array.isArray(_data["vocabularyAnnotations"])) {
                (<any>this).vocabularyAnnotations = [] as any;
                for (let item of _data["vocabularyAnnotations"])
                    (<any>this).vocabularyAnnotations!.push(IEdmVocabularyAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["referencedModels"])) {
                (<any>this).referencedModels = [] as any;
                for (let item of _data["referencedModels"])
                    (<any>this).referencedModels!.push(IEdmModel.fromJS(item));
            }
            if (Array.isArray(_data["declaredNamespaces"])) {
                (<any>this).declaredNamespaces = [] as any;
                for (let item of _data["declaredNamespaces"])
                    (<any>this).declaredNamespaces!.push(item);
            }
            this.directValueAnnotationsManager = _data["directValueAnnotationsManager"] ? IEdmDirectValueAnnotationsManager.fromJS(_data["directValueAnnotationsManager"]) : <any>undefined;
            this.entityContainer = _data["entityContainer"] ? IEdmEntityContainer.fromJS(_data["entityContainer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmModel {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.schemaElements)) {
            data["schemaElements"] = [];
            for (let item of this.schemaElements)
                data["schemaElements"].push(item.toJSON());
        }
        if (Array.isArray(this.vocabularyAnnotations)) {
            data["vocabularyAnnotations"] = [];
            for (let item of this.vocabularyAnnotations)
                data["vocabularyAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.referencedModels)) {
            data["referencedModels"] = [];
            for (let item of this.referencedModels)
                data["referencedModels"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredNamespaces)) {
            data["declaredNamespaces"] = [];
            for (let item of this.declaredNamespaces)
                data["declaredNamespaces"].push(item);
        }
        data["directValueAnnotationsManager"] = this.directValueAnnotationsManager ? this.directValueAnnotationsManager.toJSON() : <any>undefined;
        data["entityContainer"] = this.entityContainer ? this.entityContainer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIEdmModel {
    schemaElements?: IEdmSchemaElement[] | undefined;
    vocabularyAnnotations?: IEdmVocabularyAnnotation[] | undefined;
    referencedModels?: IEdmModel[] | undefined;
    declaredNamespaces?: string[] | undefined;
    directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager;
    entityContainer?: IEdmEntityContainer;
}

export class IEdmSchemaElement implements IIEdmSchemaElement {
    schemaElementKind?: EdmSchemaElementKind;
    readonly namespace?: string | undefined;
    readonly name?: string | undefined;

    constructor(data?: IIEdmSchemaElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schemaElementKind = _data["schemaElementKind"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): IEdmSchemaElement {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmSchemaElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schemaElementKind"] = this.schemaElementKind;
        data["namespace"] = this.namespace;
        data["name"] = this.name;
        return data;
    }
}

export interface IIEdmSchemaElement {
    schemaElementKind?: EdmSchemaElementKind;
    namespace?: string | undefined;
    name?: string | undefined;
}

export class IEdmTerm implements IIEdmTerm {
    type?: IEdmTypeReference;
    readonly appliesTo?: string | undefined;
    readonly defaultValue?: string | undefined;
    schemaElementKind?: EdmSchemaElementKind;
    readonly namespace?: string | undefined;
    readonly name?: string | undefined;

    constructor(data?: IIEdmTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] ? IEdmTypeReference.fromJS(_data["type"]) : <any>undefined;
            (<any>this).appliesTo = _data["appliesTo"];
            (<any>this).defaultValue = _data["defaultValue"];
            this.schemaElementKind = _data["schemaElementKind"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): IEdmTerm {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["appliesTo"] = this.appliesTo;
        data["defaultValue"] = this.defaultValue;
        data["schemaElementKind"] = this.schemaElementKind;
        data["namespace"] = this.namespace;
        data["name"] = this.name;
        return data;
    }
}

export interface IIEdmTerm {
    type?: IEdmTypeReference;
    appliesTo?: string | undefined;
    defaultValue?: string | undefined;
    schemaElementKind?: EdmSchemaElementKind;
    namespace?: string | undefined;
    name?: string | undefined;
}

export class IEdmType implements IIEdmType {
    typeKind?: EdmTypeKind;

    constructor(data?: IIEdmType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeKind = _data["typeKind"];
        }
    }

    static fromJS(data: any): IEdmType {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeKind"] = this.typeKind;
        return data;
    }
}

export interface IIEdmType {
    typeKind?: EdmTypeKind;
}

export class IEdmTypeReference implements IIEdmTypeReference {
    readonly isNullable?: boolean;
    definition?: IEdmType;

    constructor(data?: IIEdmTypeReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isNullable = _data["isNullable"];
            this.definition = _data["definition"] ? IEdmType.fromJS(_data["definition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmTypeReference {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmTypeReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNullable"] = this.isNullable;
        data["definition"] = this.definition ? this.definition.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIEdmTypeReference {
    isNullable?: boolean;
    definition?: IEdmType;
}

export class IEdmVocabularyAnnotatable implements IIEdmVocabularyAnnotatable {

    constructor(data?: IIEdmVocabularyAnnotatable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IEdmVocabularyAnnotatable {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmVocabularyAnnotatable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIEdmVocabularyAnnotatable {
}

export class IEdmVocabularyAnnotation implements IIEdmVocabularyAnnotation {
    readonly qualifier?: string | undefined;
    term?: IEdmTerm;
    target?: IEdmVocabularyAnnotatable;
    value?: IEdmExpression;

    constructor(data?: IIEdmVocabularyAnnotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).qualifier = _data["qualifier"];
            this.term = _data["term"] ? IEdmTerm.fromJS(_data["term"]) : <any>undefined;
            this.target = _data["target"] ? IEdmVocabularyAnnotatable.fromJS(_data["target"]) : <any>undefined;
            this.value = _data["value"] ? IEdmExpression.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmVocabularyAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmVocabularyAnnotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifier"] = this.qualifier;
        data["term"] = this.term ? this.term.toJSON() : <any>undefined;
        data["target"] = this.target ? this.target.toJSON() : <any>undefined;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIEdmVocabularyAnnotation {
    qualifier?: string | undefined;
    term?: IEdmTerm;
    target?: IEdmVocabularyAnnotatable;
    value?: IEdmExpression;
}

export class MessageResponse implements IMessageResponse {
    message?: string | undefined;

    constructor(data?: IMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): MessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IMessageResponse {
    message?: string | undefined;
}

export class MNO implements IMNO {
    value?: string | undefined;
    label?: string | undefined;

    constructor(data?: IMNO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): MNO {
        data = typeof data === 'object' ? data : {};
        let result = new MNO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IMNO {
    value?: string | undefined;
    label?: string | undefined;
}

export class ODataEntitySetInfo implements IODataEntitySetInfo {
    url?: string | undefined;
    name?: string | undefined;
    title?: string | undefined;
    typeAnnotation?: ODataTypeAnnotation;

    constructor(data?: IODataEntitySetInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.typeAnnotation = _data["typeAnnotation"] ? ODataTypeAnnotation.fromJS(_data["typeAnnotation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ODataEntitySetInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ODataEntitySetInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["name"] = this.name;
        data["title"] = this.title;
        data["typeAnnotation"] = this.typeAnnotation ? this.typeAnnotation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IODataEntitySetInfo {
    url?: string | undefined;
    name?: string | undefined;
    title?: string | undefined;
    typeAnnotation?: ODataTypeAnnotation;
}

export class ODataFunctionImportInfo implements IODataFunctionImportInfo {
    url?: string | undefined;
    name?: string | undefined;
    title?: string | undefined;
    typeAnnotation?: ODataTypeAnnotation;

    constructor(data?: IODataFunctionImportInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.typeAnnotation = _data["typeAnnotation"] ? ODataTypeAnnotation.fromJS(_data["typeAnnotation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ODataFunctionImportInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ODataFunctionImportInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["name"] = this.name;
        data["title"] = this.title;
        data["typeAnnotation"] = this.typeAnnotation ? this.typeAnnotation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IODataFunctionImportInfo {
    url?: string | undefined;
    name?: string | undefined;
    title?: string | undefined;
    typeAnnotation?: ODataTypeAnnotation;
}

export class ODataServiceDocument implements IODataServiceDocument {
    entitySets?: ODataEntitySetInfo[] | undefined;
    singletons?: ODataSingletonInfo[] | undefined;
    functionImports?: ODataFunctionImportInfo[] | undefined;
    typeAnnotation?: ODataTypeAnnotation;

    constructor(data?: IODataServiceDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entitySets"])) {
                this.entitySets = [] as any;
                for (let item of _data["entitySets"])
                    this.entitySets!.push(ODataEntitySetInfo.fromJS(item));
            }
            if (Array.isArray(_data["singletons"])) {
                this.singletons = [] as any;
                for (let item of _data["singletons"])
                    this.singletons!.push(ODataSingletonInfo.fromJS(item));
            }
            if (Array.isArray(_data["functionImports"])) {
                this.functionImports = [] as any;
                for (let item of _data["functionImports"])
                    this.functionImports!.push(ODataFunctionImportInfo.fromJS(item));
            }
            this.typeAnnotation = _data["typeAnnotation"] ? ODataTypeAnnotation.fromJS(_data["typeAnnotation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ODataServiceDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ODataServiceDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entitySets)) {
            data["entitySets"] = [];
            for (let item of this.entitySets)
                data["entitySets"].push(item.toJSON());
        }
        if (Array.isArray(this.singletons)) {
            data["singletons"] = [];
            for (let item of this.singletons)
                data["singletons"].push(item.toJSON());
        }
        if (Array.isArray(this.functionImports)) {
            data["functionImports"] = [];
            for (let item of this.functionImports)
                data["functionImports"].push(item.toJSON());
        }
        data["typeAnnotation"] = this.typeAnnotation ? this.typeAnnotation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IODataServiceDocument {
    entitySets?: ODataEntitySetInfo[] | undefined;
    singletons?: ODataSingletonInfo[] | undefined;
    functionImports?: ODataFunctionImportInfo[] | undefined;
    typeAnnotation?: ODataTypeAnnotation;
}

export class ODataSingletonInfo implements IODataSingletonInfo {
    url?: string | undefined;
    name?: string | undefined;
    title?: string | undefined;
    typeAnnotation?: ODataTypeAnnotation;

    constructor(data?: IODataSingletonInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.typeAnnotation = _data["typeAnnotation"] ? ODataTypeAnnotation.fromJS(_data["typeAnnotation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ODataSingletonInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ODataSingletonInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["name"] = this.name;
        data["title"] = this.title;
        data["typeAnnotation"] = this.typeAnnotation ? this.typeAnnotation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IODataSingletonInfo {
    url?: string | undefined;
    name?: string | undefined;
    title?: string | undefined;
    typeAnnotation?: ODataTypeAnnotation;
}

export class ODataTypeAnnotation implements IODataTypeAnnotation {
    typeName?: string | undefined;

    constructor(data?: IODataTypeAnnotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeName = _data["typeName"];
        }
    }

    static fromJS(data: any): ODataTypeAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ODataTypeAnnotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this.typeName;
        return data;
    }
}

export interface IODataTypeAnnotation {
    typeName?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export class ProhibitedAlphaTag implements IProhibitedAlphaTag {
    prohibitedAlphaTagId?: string | undefined;
    name?: string | undefined;

    constructor(data?: IProhibitedAlphaTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prohibitedAlphaTagId = _data["prohibitedAlphaTagId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProhibitedAlphaTag {
        data = typeof data === 'object' ? data : {};
        let result = new ProhibitedAlphaTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prohibitedAlphaTagId"] = this.prohibitedAlphaTagId;
        data["name"] = this.name;
        return data;
    }
}

export interface IProhibitedAlphaTag {
    prohibitedAlphaTagId?: string | undefined;
    name?: string | undefined;
}

export class SettingPayload implements ISettingPayload {
    settings?: Settings[] | undefined;
    mnOs?: MNO[] | undefined;
    implementers?: MNO[] | undefined;
    consent?: boolean;

    constructor(data?: ISettingPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(Settings.fromJS(item));
            }
            if (Array.isArray(_data["mnOs"])) {
                this.mnOs = [] as any;
                for (let item of _data["mnOs"])
                    this.mnOs!.push(MNO.fromJS(item));
            }
            if (Array.isArray(_data["implementers"])) {
                this.implementers = [] as any;
                for (let item of _data["implementers"])
                    this.implementers!.push(MNO.fromJS(item));
            }
            this.consent = _data["consent"];
        }
    }

    static fromJS(data: any): SettingPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SettingPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        if (Array.isArray(this.mnOs)) {
            data["mnOs"] = [];
            for (let item of this.mnOs)
                data["mnOs"].push(item.toJSON());
        }
        if (Array.isArray(this.implementers)) {
            data["implementers"] = [];
            for (let item of this.implementers)
                data["implementers"].push(item.toJSON());
        }
        data["consent"] = this.consent;
        return data;
    }
}

export interface ISettingPayload {
    settings?: Settings[] | undefined;
    mnOs?: MNO[] | undefined;
    implementers?: MNO[] | undefined;
    consent?: boolean;
}

export class Settings implements ISettings {
    clientAbn?: string | undefined;
    clientName?: string | undefined;
    isRepresentative?: boolean | undefined;
    isParticipant?: boolean | undefined;
    isMno?: boolean | undefined;
    clientId?: string | undefined;
    requestMailbox?: string | undefined;
    alphaTagMailbox?: string | undefined;
    authorisationMailbox?: string | undefined;
    firewallMailbox?: string | undefined;
    alphaTagWebhook?: string | undefined;
    authorisationWebhook?: string | undefined;

    constructor(data?: ISettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientAbn = _data["clientAbn"];
            this.clientName = _data["clientName"];
            this.isRepresentative = _data["isRepresentative"];
            this.isParticipant = _data["isParticipant"];
            this.isMno = _data["isMno"];
            this.clientId = _data["clientId"];
            this.requestMailbox = _data["requestMailbox"];
            this.alphaTagMailbox = _data["alphaTagMailbox"];
            this.authorisationMailbox = _data["authorisationMailbox"];
            this.firewallMailbox = _data["firewallMailbox"];
            this.alphaTagWebhook = _data["alphaTagWebhook"];
            this.authorisationWebhook = _data["authorisationWebhook"];
        }
    }

    static fromJS(data: any): Settings {
        data = typeof data === 'object' ? data : {};
        let result = new Settings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientAbn"] = this.clientAbn;
        data["clientName"] = this.clientName;
        data["isRepresentative"] = this.isRepresentative;
        data["isParticipant"] = this.isParticipant;
        data["isMno"] = this.isMno;
        data["clientId"] = this.clientId;
        data["requestMailbox"] = this.requestMailbox;
        data["alphaTagMailbox"] = this.alphaTagMailbox;
        data["authorisationMailbox"] = this.authorisationMailbox;
        data["firewallMailbox"] = this.firewallMailbox;
        data["alphaTagWebhook"] = this.alphaTagWebhook;
        data["authorisationWebhook"] = this.authorisationWebhook;
        return data;
    }
}

export interface ISettings {
    clientAbn?: string | undefined;
    clientName?: string | undefined;
    isRepresentative?: boolean | undefined;
    isParticipant?: boolean | undefined;
    isMno?: boolean | undefined;
    clientId?: string | undefined;
    requestMailbox?: string | undefined;
    alphaTagMailbox?: string | undefined;
    authorisationMailbox?: string | undefined;
    firewallMailbox?: string | undefined;
    alphaTagWebhook?: string | undefined;
    authorisationWebhook?: string | undefined;
}

export class SettingsBase implements ISettingsBase {
    clientId?: string | undefined;
    requestMailbox?: string | undefined;
    alphaTagMailbox?: string | undefined;
    authorisationMailbox?: string | undefined;
    firewallMailbox?: string | undefined;
    alphaTagWebhook?: string | undefined;
    authorisationWebhook?: string | undefined;

    constructor(data?: ISettingsBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.requestMailbox = _data["requestMailbox"];
            this.alphaTagMailbox = _data["alphaTagMailbox"];
            this.authorisationMailbox = _data["authorisationMailbox"];
            this.firewallMailbox = _data["firewallMailbox"];
            this.alphaTagWebhook = _data["alphaTagWebhook"];
            this.authorisationWebhook = _data["authorisationWebhook"];
        }
    }

    static fromJS(data: any): SettingsBase {
        data = typeof data === 'object' ? data : {};
        let result = new SettingsBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["requestMailbox"] = this.requestMailbox;
        data["alphaTagMailbox"] = this.alphaTagMailbox;
        data["authorisationMailbox"] = this.authorisationMailbox;
        data["firewallMailbox"] = this.firewallMailbox;
        data["alphaTagWebhook"] = this.alphaTagWebhook;
        data["authorisationWebhook"] = this.authorisationWebhook;
        return data;
    }
}

export interface ISettingsBase {
    clientId?: string | undefined;
    requestMailbox?: string | undefined;
    alphaTagMailbox?: string | undefined;
    authorisationMailbox?: string | undefined;
    firewallMailbox?: string | undefined;
    alphaTagWebhook?: string | undefined;
    authorisationWebhook?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}